import { Box, Typography } from "@mui/material";
import Image from "next/image";
import QuestionMarquee from "../QuestionMarquee";
import useDevice from "@/hooks/useDevice";
import gaService from "@/api/services/ga.service";

const NewConversationalLanding = () => {
  const isMobile = useDevice();
  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        gap: isMobile ? 1 : 3,
      }}
    >
      <Box
        sx={{
          height: "100%",
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          maxWidth: { md: "70%", sm: "100%" },
          textAlign: "center",
          gap: isMobile ? 1: 3,
          mt:isMobile ?  0 : 5,
        }}
      >
        <Image
          src="https://sr-cdn-1.shiprocket.in/sr-promise/images/trends_ai_chat_icon.svg"
          alt="Trends AI"
          width={60}
          height={60}
          style={isMobile ? { width: "60px", height: "60px" } :  { width: "40px", height: "40px" }}
        />
        <Typography variant="h2">Welcome to Trends AI</Typography>
        <Typography variant="body2">
          Start exploring your ecommerce analytics through conversational AI.
          Ask questions about sales trends, customer behavior, or regional
          performance.
        </Typography>

        <Box
          sx={{
            backgroundColor: "#FFD76F1A",
            color: "#FFD76F",
            p: 2,
            borderRadius: 4,
            fontSize: "14px",
          }}
        >
          💡 Use the example prompts below or click on dashboard tabs to explore
          specific insights.
        </Box>
      </Box>
      <QuestionMarquee
        onClick={(msg: string) => {
          if (typeof window !== "undefined") {
            gaService.conversationSuggestedPromptClicked(msg, "new_chat")
            window.dispatchEvent(
              new CustomEvent("conversational:setInput", {
                detail: { msg }, // 👈 match the listener
              })
            );
          }
        }}
      />
    </Box>
  );
};

export default NewConversationalLanding;
